import './bootstrap';

import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import { Head, Link } from "@inertiajs/vue3";
import VueGtag from "vue-gtag";
import { pageview } from "vue-gtag";

import { FontAwesomeIcon } from '@/fontawesome'

import { VueReCaptcha } from 'vue-recaptcha-v3'

import Layout from '@/Layouts/Full.vue'
import { router } from '@inertiajs/vue3'

createInertiaApp({
    title: title => title || 'Inevat - Managed IT & Cybersecurity',
    resolve: async name => {
        const pages = import.meta.glob('./Pages/**/*.vue')
        const page = await pages[`./Pages/${name}.vue`]()
        page.default.layout = page.default.layout || Layout
        return page
    },
    setup({ el, App, props, plugin }) {
        const captcheKey = props.initialPage.props.recaptcha_site_key;
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(VueReCaptcha, { siteKey: captcheKey } )
            .use(VueGtag, {
                appName: 'inevat.com',
                pageTrackerScreenviewEnabled: true,
                config: { id: "G-3H9J72662S" }
            })
            .component("Head", Head)
            .component("Link", Link)
            .component("font-awesome-icon", FontAwesomeIcon)
            .mount(el)
    },
})


let isInitialNavigation = true

router.on('navigate', (event) => {
    if(event.detail.page.props && event.detail.page.props.meta) {
        pageview({
            page_path: event.detail.page.url,
            page_title: event.detail.page.props.meta.title,
        })
    } else {
        pageview({
            page_path: event.detail.page.url
        })
    }

    // The pixel snippet in app.blade.php already tracks the initial page load
    if (isInitialNavigation) {
        isInitialNavigation = false
        return
    }

    if (typeof window.fbq === 'function') {
        window.fbq('track', 'PageView')
    }
})